import { render, staticRenderFns } from "./WaybillFileRecords.vue?vue&type=template&id=4c16c0d6&scoped=true"
import script from "./WaybillFileRecords.vue?vue&type=script&lang=js"
export * from "./WaybillFileRecords.vue?vue&type=script&lang=js"
import style0 from "./WaybillFileRecords.vue?vue&type=style&index=0&id=4c16c0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16c0d6",
  null
  
)

export default component.exports